// Keep French punctuation attached to the preceding word without changing markup or stored text.
export function prepareHeadings(root = document) {
    if (!/^fr(?:-|$)/i.test(document.documentElement.lang)) return;
    root.querySelectorAll('h1, h2, h3, h4, h5, h6').forEach(heading => {
        if (heading.closest('[contenteditable], .ui-input-rich')) return;
        const walker = document.createTreeWalker(heading, NodeFilter.SHOW_TEXT);
        let node;
        while ((node = walker.nextNode())) {
            if (node.parentElement.closest('code, pre, [contenteditable]')) continue;
            node.textContent = node.textContent.replace(/ ([;:!?])/g, '\u00a0$1');
        }
    });
}
if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => prepareHeadings());
} else {
    prepareHeadings();
}
